import * as React from "react";
import { localeForLang, useLang } from "../../utils/i18n/lang";
import { priceFormat } from "../../domain/price";

interface Props {
    value: number;
    currency: string;
}

export const LocalCurrency = (p: Props) => {
    const lang = useLang();

    const formatted = React.useMemo(() => {
        const locale = localeForLang(lang);
        const format = priceFormat(locale, p.currency);
        return format.format(p.value);
    }, [p.value, p.currency, lang]);

    return <span>{formatted}</span>;
};
